@if (variant === 'menu') {
  <div
    class="flex gap-2 white-space-nowrap"
    [ngClass]="{
      'p-button-xs p-button p-button-secondary p-button-text p-button-raised p-button-rounded':
        menuItems.length > 1 && !readonly,
    }"
    (click)="menu.toggle($event)">
    <span>{{ activeCaption }}</span>
    @if (menuItems.length > 1 && !readonly) {
      <i class="fas fa-chevron-down text-xs"></i>
    }
  </div>
  <p-menu
    [style]="{ 'max-height': '20rem', overflow: 'auto' }"
    appendTo="body"
    #menu
    [model]="menuItems"
    [popup]="true" />
} @else if (widget.widget.focusProperty) {
  <app-form-field-wrapper
    name="indicator"
    [label]="labels[widget.widget.focusProperty]"
    [floatingLabel]="false"
    [colSize]="12">
    <p-dropdown
      optionValue="value"
      [ngModel]="selection"
      [options]="menuItems"
      (onChange)="updateChart($event.value)"
      [style]="{ width: '100%' }"></p-dropdown>
  </app-form-field-wrapper>
}
